import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import {
  CheckBoxWrapper,
  ItemTitle,
  ItemTitleWrapper,
  TitleIconWrapper,
} from './ProductFilter';
import { useState } from 'react';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { FlexRowCenterVertical, TextP } from '../../../index';
import { Input } from '../../Zemplin/General/Input';
import { getSymbolFromCurrency, prop } from '../../../utilities';
import { __ } from 'react-i18n';
import { FilterType } from './CategoryFilter';

interface Props {
  type: string;
  name: string;
  data?: any;
  isDropdownOpen?: boolean;
  theme: any;
  handleFilterChange: any;
  priceInitial: any;
  priceCurrent: any;
  currency: string;
  hasOnStockFilter?: boolean;
  hasOnlyWithParentFitler?: boolean;
  aggData?: boolean;
  ignoreFilters?: string[];
}

function ProductFilterItem({
  type,
  name,
  data,
  isDropdownOpen = false,
  theme,
  handleFilterChange,
  priceInitial,
  priceCurrent,
  currency,
  hasOnStockFilter,
  hasOnlyWithParentFitler,
  aggData,
  ignoreFilters
}: Props) {
  const [isOpen, setIsOpen] = useState(isDropdownOpen);
  const [minValue, setMinValue] = useState(priceCurrent.min);
  const [maxValue, setMaxValue] = useState(priceCurrent.max);
  const [typingTimeout, setTypingTimeout]: any = useState(0);

  React.useEffect(() => {
    setMinValue(priceCurrent.min);
    setMaxValue(priceCurrent.max);
  }, [priceCurrent, setMaxValue, setMinValue]);
  // React.useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     // if ()
  //     console.log({ minValue, maxValue });
  //     // handleFilterChange('RANGE', { min: minValue, max: maxValue });
  //   }, 1000);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [minValue, maxValue]);

  const changeIsOpenState = () => {
    setIsOpen(!isOpen);
  };

  const changeLimitValues = value => {
    setMinValue(value[0]);
    setMaxValue(value[1]);
  };

  const handleAfterChange = value => {
    // handleFilterChange('RANGE', { min: value[0], max: value[1] });
    if (
      priceCurrent.min !== minValue.toFixed(0) ||
      priceCurrent.max !== maxValue.toFixed(0)
    ) {
      handleFilterChange(FilterType.RANGE, {
        min: minValue,
        max: maxValue,
      });
      setMinValue(minValue.toFixed(0));
      setMaxValue(maxValue.toFixed(0));
    }
  };

  const handleMinInputChange = e => {
    setMinValue(e.target.value);
  };

  const handleMaxInputChange = e => {
    setMaxValue(e.target.value);
  };

  // const handleMinInputChange = e => {
  //   const val = e.target.value;
  //   setMinValue(+val);

  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }

  //   setTypingTimeout(
  //     setTimeout(() => {
  //       handleFilterChange('RANGE', { min: +val, max: maxValue });
  //     }, 1000),
  //   );
  // };

  // const handleMaxInputChange = e => {
  //   const val = e.target.value;
  //   setMaxValue(+val);

  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }

  //   setTypingTimeout(
  //     setTimeout(() => {
  //       handleFilterChange('RANGE', { min: minValue, max: +val });
  //     }, 1000),
  //   );
  // };

  const handleMinBlur = e => {
    const initialMin = priceInitial.min;
    const min = priceCurrent.min;
    let value = e.target.value;
    if (isNaN(value)) {
      value = initialMin;
    } else if (value < initialMin) {
      value = initialMin.toFixed(0);
    } else if (value > maxValue) {
      value = maxValue.toFixed(0);
    } else {
      value = parseInt(value, 10).toFixed(0);
    }
    if (value !== min.toString()) {
      setMinValue(value);

      handleFilterChange(FilterType.RANGE, {
        min: parseInt(value, 10),
        max: parseInt(maxValue, 10),
      });
    } else {
      setMinValue(value);
    }
  };

  const handleMaxBlur = e => {
    const initialMax = priceInitial.max;
    const max = priceCurrent.max;
    let value = e.target.value;
    if (isNaN(value)) {
      value = initialMax;
    } else if (value > initialMax) {
      value = initialMax.toFixed(0);
    } else if (value < minValue) {
      value = minValue.toFixed(0);
    } else {
      value = parseInt(value, 10).toFixed(0);
    }

    if (value !== max.toString()) {
      setMaxValue(value);

      handleFilterChange(FilterType.RANGE, {
        min: parseInt(minValue, 10),
        max: parseInt(value, 10),
      });
    } else {
      setMaxValue(value);
    }
  };

  const handleCheckboxChange = e => {
    handleFilterChange(FilterType.CHECK, e);
  };

  return (
    <>
      <ItemTitleWrapper onClick={changeIsOpenState} isOpen={isOpen}>
        <ItemTitle>{name}</ItemTitle>
        <TitleIconWrapper>
          <TitleIcon
            icon={isOpen ? IconType.bottomArrow : IconType.topArrow}
            viewBox="0 0 16 16"
            width={24}
            height={25}
          />
        </TitleIconWrapper>
      </ItemTitleWrapper>
      {isOpen &&
        (type === 'price' ? (
          <PriceFilterDropdown>
            <Range
              min={priceInitial.min}
              max={priceInitial.max}
              allowCross={true}
              value={[
                minValue,
                maxValue && maxValue > priceInitial.min
                  ? maxValue
                  : priceInitial.min,
              ]}
              onChange={changeLimitValues}
              onAfterChange={handleAfterChange}
              handleStyle={[
                {
                  backgroundColor: theme.categoryColors.handle.background,
                  border: theme.categoryColors.handle.border,
                },
                {
                  backgroundColor: theme.categoryColors.handle.background,
                  border: theme.categoryColors.handle.border,
                },
              ]}
              trackStyle={[
                { backgroundColor: theme.categoryColors.track.background },
              ]}
              railStyle={{
                backgroundColor: theme.categoryColors.rail.background,
              }}
            />
            <InputRow>
              <PriceLimitInput
                type="number"
                value={minValue}
                onChange={handleMinInputChange}
                onBlur={handleMinBlur}
                disabled={true}
              />
              <TextP style={{ marginRight: 16, marginLeft: 16 }}>-</TextP>
              <PriceLimitInput
                type="number"
                value={maxValue}
                onChange={handleMaxInputChange}
                onBlur={handleMaxBlur}
                disabled={true}
              />
              <TextP style={{ marginLeft: 16 }}>
                {getSymbolFromCurrency(currency)}
              </TextP>
            </InputRow>
            <FilterDropdown>
              <CheckBoxesWrapper>
                {hasOnStockFilter && (
                  <>
                    <CheckBoxWrapper>
                      <CheckBox
                        key={'onlyAvailable'}
                        name="onlyAvailable"
                        label={__('Iba na sklade')}
                        type={'checkbox'}
                        selected={prop(data, 'onlyAvailable') === '1'}
                        onClick={handleCheckboxChange}
                      />
                    </CheckBoxWrapper>
                    {prop(aggData, 'includesSales') && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'sale'}
                          name="sale"
                          label={__('V akcii')}
                          type={'checkbox'}
                          selected={prop(data, 'sale') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                    {(prop(aggData, 'includesGifts') && (!ignoreFilters?.length || !ignoreFilters.includes('hasGift'))) && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'hasGift'}
                          name="hasGift"
                          label={__('S darčekom')}
                          type={'checkbox'}
                          selected={prop(data, 'hasGift') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                    {prop(aggData, 'includesRecycled') && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'onlyWithoutParent'}
                          name="onlyWithoutParent"
                          label={__('Iba nové')}
                          type={'checkbox'}
                          selected={prop(data, 'onlyWithoutParent') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                    {prop(aggData, 'includesRecycled') && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'onlyWithParent'}
                          name="onlyWithParent"
                          label={__('Bazár')}
                          type={'checkbox'}
                          selected={prop(data, 'onlyWithParent') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                    {(prop(aggData, 'includesFreeDelivery') && (!ignoreFilters?.length || !ignoreFilters.includes('freeDelivery'))) && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'freeDelivery'}
                          name="freeDelivery"
                          label={__('Doprava zadarmo')}
                          type={'checkbox'}
                          selected={prop(data, 'freeDelivery') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                    {(prop(aggData, 'includesNew') && (!ignoreFilters?.length || !ignoreFilters.includes('new'))) && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'new'}
                          name="new"
                          label={__('Novinky')}
                          type={'checkbox'}
                          selected={prop(data, 'new') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                  </>
                )}

                {hasOnlyWithParentFitler && !hasOnStockFilter && (
                  <>
                    {prop(aggData, 'includesRecycled') && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'onlyWithoutParent'}
                          name="onlyWithoutParent"
                          label={__('Iba nové')}
                          type={'checkbox'}
                          selected={prop(data, 'onlyWithoutParent') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                    {prop(aggData, 'includesRecycled') && (
                      <CheckBoxWrapper>
                        <CheckBox
                          key={'onlyWithParent'}
                          name="onlyWithParent"
                          label={__('Bazár')}
                          type={'checkbox'}
                          selected={prop(data, 'onlyWithParent') === '1'}
                          onClick={handleCheckboxChange}
                        />
                      </CheckBoxWrapper>
                    )}
                  </>
                )}

                {/* <CheckBoxWrapper>
                  <CheckBox
                    name={name}
                    selected={true}
                    responsiveMarginBottom={16}
                  />
                  <StyledLabel htmlFor={name} selected={true}>
                    {'V akcii'}
                  </StyledLabel>
                </CheckBoxWrapper>
                <CheckBoxWrapper>
                  <CheckBox
                    name={name}
                    selected={false}
                    responsiveMarginBottom={24}
                  />
                  <StyledLabel htmlFor={name} selected={false}>
                    {'S darčekom'}
                  </StyledLabel>
                </CheckBoxWrapper> */}
              </CheckBoxesWrapper>
              {/* <CheckBoxesWrapper>
                <CheckBoxRow>
                  <CheckBoxWrapper>
                    <CheckBox
                      name="withVat"
                      selected={true}
                      rounded={true}
                      responsiveMarginBottom={24}
                    />
                    <StyledLabel htmlFor="withVat" selected={true}>
                      {'s DPH'}
                    </StyledLabel>
                  </CheckBoxWrapper>
                  <CheckBoxWrapper>
                    <CheckBox
                      name="withoutVat"
                      selected={false}
                      rounded={true}
                      responsiveMarginBottom={24}
                    />
                    <StyledLabel htmlFor="withoutVat" selected={false}>
                      {'bez DPH'}
                    </StyledLabel>
                  </CheckBoxWrapper>
                </CheckBoxRow>
              </CheckBoxesWrapper>
              <CheckBoxesWrapper>
                <CheckBoxRow>
                  <CheckBoxWrapper>
                    <CheckBox
                      name="voc"
                      selected={true}
                      rounded={true}
                      responsiveMarginBottom={0}
                    />
                    <StyledLabel htmlFor="voc" selected={true}>
                      {'VOC'}
                    </StyledLabel>
                  </CheckBoxWrapper>
                  <CheckBoxWrapper>
                    <CheckBox
                      name="moc"
                      selected={false}
                      rounded={true}
                      responsiveMarginBottom={0}
                    />
                    <StyledLabel htmlFor="moc" selected={false}>
                      {'MOC'}
                    </StyledLabel>
                  </CheckBoxWrapper>
                </CheckBoxRow>
              </CheckBoxesWrapper>*/}
            </FilterDropdown>
          </PriceFilterDropdown>
        ) : (
          <SelectFilterDropdown>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                type={'checkbox'}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={true}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={true}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <CheckBox
                name={name}
                selected={false}
                responsiveMarginBottom={16}
              />
              <StyledLabel htmlFor={name} selected={false}>
                {'AKG'}
              </StyledLabel>
            </CheckBoxWrapper>
          </SelectFilterDropdown>
        ))}
    </>
  );
}

const FilterDropdown = styled.div`
  margin-top: ${rem(32)};
`;

const PriceFilterDropdown = styled(FilterDropdown)`
  ${({ theme }) => theme.mediab.l925`
    margin-top: ${rem(24)};
  `}
`;

const InputRow = styled(FlexRowCenterVertical)`
  margin-top: ${rem(32)};

  ${({ theme }) => theme.mediab.l925`
    margin-top: ${rem(24)};
  `}
`;

const PriceLimitInput = styled(Input)`
  width: ${rem(85)};
  box-shadow: 0 ${rem(1)} ${rem(4)} #00000014;
  border: ${rem(1)} solid #cccccc;
  border-radius: ${rem(4)};
  padding-left: ${rem(10)};
  padding-right: ${rem(10)};

  &:read-only {
    background-color: #ffffff;
  }
`;

const SelectFilterDropdown = styled(FilterDropdown)`
  max-height: ${rem(165)};
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: ${rem(2)};
    border-radius: 2px;
  }
  ::-webkit-scrollbar-track {
    background: rgba(30, 57, 141, 0.08);
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.productFilter.scrollbarColor};
  }
`;

export const StyledLabel = styled.label<{ selected: boolean }>`
  font-size: ${rem(16)};
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  color: ${({ selected, theme }) =>
    selected
      ? theme.categoryColors.productFilterLabel
      : theme.colors.textPrimary};
  margin-right: ${rem(24)};
`;

const TitleIcon = styled(SvgIcon)`
  z-index: 1;
  position: relative;
  top: ${rem(10)};
  left: ${rem(10)};
`;

const CheckBoxRow = styled(FlexRowCenterVertical)`
  padding-top: ${rem(16)};

  ${({ theme }) => theme.mediab.l925`
    padding: 0;
  `}
`;

const CheckBoxesWrapper = styled.div`
  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    padding-top: 0;
  }

  ${({ theme }) => theme.mediab.l925`
  
    border-bottom: ${rem(1)} solid #eeeeee;
    margin-left: ${rem(-16)};
    margin-right: ${rem(-16)};
    padding: 0 ${rem(16)};
    padding-top: ${rem(24)};
  `}
`;

const ProductFilterItemWithTheme: any = withTheme(ProductFilterItem);
export { ProductFilterItemWithTheme as ProductFilterItem };
